import * as Yup from 'yup'

import { t } from '../../../translations'

export const validation = Yup.object().shape({
  email: Yup.string().email(t('validation_messages.email_invalid')).required(t('login.enter_email')),
  password: Yup.string().required(t('login.enter_password')),
})
